import { render, staticRenderFns } from "./AreaBase.vue?vue&type=template&id=400d6eda&scoped=true"
import script from "./AreaBase.vue?vue&type=script&lang=js"
export * from "./AreaBase.vue?vue&type=script&lang=js"
import style0 from "./AreaBase.vue?vue&type=style&index=0&id=400d6eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400d6eda",
  null
  
)

export default component.exports